export const OTHER_KEY_MAP: Record<string, string> = {
  plus: '+',
};

export const MAC_OS_KEY_MAP: Record<string, string> = {
  command: '⌘',
  alt: '⌥',
  plus: '+',
  option: '⌥',
  ctrl: '⌃',
  shift: '⇧',
};
